import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportListComponent } from './report-list/report-list.component';

export const reportRoutes: Routes = [
  {
    path: 'report',
    children: [
      {
        path: 'download',
        component: ReportListComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportRoutes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report-routing.module.ts